export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const CHANGE_USER_COMPANY = 'CHANGE_USER_COMPANY';
